var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.data.color)?_c('div',{staticClass:"item-badge",style:(_vm.styleObject)}):_vm._e(),_vm._v(" "+_vm._s(_vm.data.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }